"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNLEASH_FEATURE_ARRAY = exports.UNLEASH_FEATURE_NAMES = exports.getUnleashFeatureWithPodletPrefix = void 0;
function getUnleashFeatureWithPodletPrefix(nameId) {
    return "advertising-podlet.".concat(nameId);
}
exports.getUnleashFeatureWithPodletPrefix = getUnleashFeatureWithPodletPrefix;
exports.UNLEASH_FEATURE_NAMES = {
    // Server features
    killSwitch: 'killswitch',
    mockApi: 'mockApi',
    iframeHeightOnBanners: 'iframeHeightOnBanners',
    xandrFallbackVersion: 'xandrFallbackVersion',
    forceUnleashTestMemberId: 'forceUnleashTestMemberId',
    enableServerAfsDiv: 'enableServerAfsDiv',
    disableRelevantDigital: 'disableRelevantDigital',
    disableSafeFrame: 'disableSafeFrame',
    enableAfsPlacements: 'enableAfsPlacements'
};
exports.UNLEASH_FEATURE_ARRAY = Object.values(exports.UNLEASH_FEATURE_NAMES);
